import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'mobile_basic',
    emoji: '🎒',
    name: 'Mobile Basic',
    description: '2 cameras + 2 mics + technician',
    price: 6500000,
    duration: 'Per day',
    features: ['2 x 4K cameras', '2 microphones', '2 LED lights', 'Dedicated technician', 'Delivery + pickup']
  },
  {
    id: 'mobile_standard',
    emoji: '📦',
    name: 'Mobile Standard',
    description: '3 cameras + 4 mics + backdrop',
    price: 8500000,
    duration: 'Per day',
    popular: true,
    features: ['3 x 4K cameras', '4 microphones', '3-point lighting', 'Portable backdrop', 'Dedicated technician']
  },
  {
    id: 'mobile_pro',
    emoji: '🏆',
    name: 'Mobile Pro',
    description: 'Full setup + senior technician',
    price: 14000000,
    duration: 'Per day',
    features: ['3 x 4K cameras', '4 microphones', 'Pro lighting kit', 'Color backdrop choice', 'Senior technician']
  }
];

const addons = [];

const customFields = [
  { id: 'location', label: 'Filming location address', type: 'textarea', required: true, placeholder: 'Full address where equipment will be delivered...' },
  { id: 'distance', label: 'Approximate distance from Canggu', type: 'text', placeholder: '5km, 10km, etc.' },
  { id: 'event_type', label: 'Type of event / content', type: 'text', placeholder: 'Corporate event, interview, workshop...' },
  { id: 'duration', label: 'Expected filming duration', type: 'text', placeholder: '4 hours, full day...' }
];

export default function MobileKitBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="mobile_kit"
      serviceTitle="Mobile Equipment"
      serviceSubtitle="On-location filming with technician"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/mobile-kit"
    />
  );
}
